import './GoalIntake.scss';
import { useState } from 'react';
import { MdOutlineSettings } from 'react-icons/md';
import { Button } from '@Components/Button/Button';
import { Size } from '@Components/designConstants';
import { Page } from '@Components/Page/Page';
import { PAGE_NAMES } from '@Components/Page/page-constants';
import { useAppSelector } from '@src/redux';
import { currentCompanySelector } from '@src/redux/company';
import { GoalIntakeGoals } from './GoalIntakeGoals';
import { GoalIntakeSettingsModal } from './GoalIntakeSettingsModal';
import { useGoalRows } from './use-goal-intake';

// A preview of the new Goal Intake at its own URL; the current page is untouched.
export const GoalIntakeNew = () => {
  const company = useAppSelector(currentCompanySelector);
  // Shares its cache with GoalIntakeGoals' own call -- only here to time the page load.
  const { isLoading } = useGoalRows(company);
  const [showSettings, setShowSettings] = useState(false);

  return (
    <Page
      title={PAGE_NAMES.GOAL_INTAKE_NEW}
      pageType={PAGE_NAMES.GOAL_INTAKE_NEW}
      isLoading={isLoading}
      actions={
        <Button
          size={Size.LG}
          leadingElement={<MdOutlineSettings />}
          data-testid='goal-intake-new-settings-button'
          onClick={() => setShowSettings(true)}
        >
          Settings
        </Button>
      }
    >
      <GoalIntakeGoals company={company} />
      {showSettings && (
        <GoalIntakeSettingsModal company={company} onHide={() => setShowSettings(false)} />
      )}
    </Page>
  );
};
